module.exports = __webpack_public_path__ + "img/hsf-logo.8c6d5307.jpg";